import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ToggleField from "widgets/ToggleField";
import { toggleCreativeAutoUpdates } from "reducers/actions/ContentFeedActions";

import "./AssignedCreativeEnableUpdate.css";

export default function AssignedCreativeEnableUpdate({ value, dependentValues }) {
	const { contentFeedId, idCreative } = dependentValues;
	const [isUpdating, setIsUpdating] = useState(false);
	const dispatch = useDispatch();

	const handleToggle = (autoUpdate) => {
		setIsUpdating(true);
		dispatch(toggleCreativeAutoUpdates(contentFeedId, idCreative, autoUpdate))
			.finally(() => {
				setIsUpdating(false);
			});
	};

	return (
		<div className="assigned-creative-enable-update">
			<ToggleField
				input={{
					value,
					onChange: handleToggle,
				}}
				loading={isUpdating}
			/>
		</div>
	);
}

